import Vue from "vue";
import Vuex from "vuex";

// global
import state from "@app/store/state";
import actions from "@app/store/actions";
import mutations from "@app/store/mutations";
import getters from "@app/store/getters";

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});

export default store;
